import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
  search: {
    params: SearchParams.Industry;
    ids: string[];
  };
};

export const adapter = createEntityAdapter<Model.Industry>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'industry',
  initialState: adapter.getInitialState<State>({
    loading: false,
    search: {
      params: {},
      ids: [],
    },
  }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Industry[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Industry>) {
      adapter.upsertOne(state, action);
      state.search.ids = [...(state.search.ids || []), action.payload.id];
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    removeEntity(state, action: PayloadAction<Model.Industry>) {
      adapter.removeOne(state, action.payload.id);
      state.search.ids = (state.search.ids || []).filter(
        (id) => id !== action.payload.id,
      );
    },
    updateSearch(state, action: PayloadAction<State['search']>) {
      state.search = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.industry,
);

export const selectionIndustriesBySearch = createSelector(
  selector.selectAll,
  selector.selectEntities,
  (state: RootState) => state.model.industry.search,
  (industries, entities, { params, ids }) => {
    if (params.q || params.recursive_focus_only) {
      return ids.map((id) => entities[id]!);
    }
    return industries;
  },
);

export const selectIndustriesOptions = createSelector(
  selector.selectAll,
  (list) => {
    return list.map((i) => ({ value: i.name, text: i.name, key: i.id }));
  },
);

export { reducer };
export default actions;
